// Values list: the last row whose top has crossed the viewport midpoint is the
// revealed one, so scrolling back up un-reveals in step.
export function initValuesReveal() {
  if (matchMedia('(prefers-reduced-motion:reduce)').matches) return;
  var sec = document.querySelector('.values-list');
  if (!sec) return;
  sec.classList.add('is-armed');
  var rows = [].slice.call(sec.querySelectorAll('.value-row')).filter(function (r) {
    var n = r.querySelector('.value-row__number');
    return n && /\d/.test(n.textContent);
  });
  if (!rows.length) return;
  var cur = null;
  function chk() {
    var mid = innerHeight / 2,
      act = null;
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].getBoundingClientRect().top < mid) act = rows[i];
    }
    if (act === cur) return;
    if (cur) cur.classList.remove('is-revealed');
    if (act) act.classList.add('is-revealed');
    cur = act;
  }
  addEventListener('scroll', chk, { passive: true });
  addEventListener('resize', chk);
  chk();
}
